// import React from 'react'

const t = {
    FR: {
        'created': 'Créé',
        'started': 'Débuté',
        'finished': 'Terminé',
        'cancelled': 'Annulé',
        'Manage categories': 'Gérer les catégories',
        'Add category': 'Ajouter une catégorie',
        'Add item': 'Ajouter un élément',
        'Edit': 'Éditer',
        'Delete': 'Retirer',
        'No delete': 'Impossible de supprimer la dernière catégorie',
        'changeStatusTo': 'Changer le statut à',
        'undo': 'Ne rien changer',
        'History': 'Historique',

        'Future feature': 'Fonctionnalité future',
    },
    EN: {
        'created': 'Created',
        'started': 'Started',
        'finished': 'Finished',
        'cancelled': 'Cancelled',
        'Manage categories': 'Manage catégories',
        'Add category': 'Add a category',
        'Add item': 'Add an item',
        'Edit': 'Edit',
        'Delete': 'Delete',
        'No delete': `Can't delete the last category`,
        'changeStatusTo': 'Change status to',
        'undo': 'Change nothing',
        'History': 'History',

        'Future feature': 'Future feature',
    },
    ES: {
        'created': 'Creado',
        'started': 'Comenzó',
        'finished': 'Finalizado',
        'cancelled': 'Cancelado',
        'Manage categories': 'Administrar categorías',
        'Add category': 'Agregar una categoría',
        'Add item': 'Agregar un artículo',
        'Edit': 'Editar',
        'Delete': 'Borrar',
        'No delete': 'No se puede eliminar la última categoría',
        'changeStatusTo': 'Cambiar estado a',
        'undo': 'No cambies nada',
        'History': 'Historia',

        'Future feature': 'Característica futura',
    },
    PT: {
        'created': 'Criado',
        'started': 'Iniciado',
        'finished': 'Finalizado',
        'cancelled': 'Cancelado',
        'Manage categories': 'Gerenciar categorias',
        'Add category': 'Adicionar uma categoria',
        'Add item': 'Adicionar um item',
        'Edit': 'Editar',
        'Delete': 'Excluir',
        'No delete': 'Não é possível excluir a última categoria',
        'changeStatusTo': 'Alterar status para',
        'undo': 'Não mude nada',
        'History': 'História',

        'Future feature': 'Característica futura',
    },
}

export default t